const appPermissions = {
  ModuleAggrements: {
    createContract: {
      privileges: ['LICENSE_FULL_ACCESS', 'CONTRACT_CREATE'],
    },
    modifyContract: {
      privileges: ['LICENSE_FULL_ACCESS', 'CONTRACT_MODIFY'],
    },
    modifyContractExtension: {
      privileges: [
        'LICENSE_FULL_ACCESS',
        'CONTRACT_MODIFYDATES',
      ],
    },
    btnCreateContract: {
      privileges: ['LICENSE_FULL_ACCESS', 'CONTRACT_CREATE'],
    },
    showAllProducts: {
      privileges: ['LICENSE_FULL_ACCESS', 'LICENSE_CONTRACT_ALLPRODUCTS'],
    },
    annulmentContract: {
      privileges: ['LICENSE_FULL_ACCESS', 'LICENSE_CONTRACT_ANNULMENT'],
    },
  },
  ModuleDashboard: {
    btnExportExcel: {
      privileges: ['LICENSE_FULL_ACCESS', 'DASHBOARD_EXPORTEXCEL'],
    },
    searchCustomer:{
      privileges: ['LICENSE_FULL_ACCESS', 'LICENSE_DASHBOARDCUSTOMER_SEARCH'],
    }
  },
  ModulePayments: {
    btnExportExcel: {
      isActivate: true,
      isShowed: true,
      privileges: ['LICENSE_FULL_ACCESS', 'DASHBOARD_EXPORTEXCEL'],
    },
  },
  ModuleReports: {
    btnExportExcel: {
      isActivate: true,
      isShowed: true,
      privileges: ['LICENSE_FULL_ACCESS', 'DASHBOARD_EXPORTEXCEL'],
    },
  },
  ModuleLicenses: {
    btnEditCustomer: {
      isActivate: true,
      isShowed: true,
      privileges: ['LICENSE_FULL_ACCESS', 'LICENSE_CUSTOMER_UPDATE'],
    },
    btnCreateCustomer: {
      isActivate: true,
      isShowed: true,
      privileges: ['LICENSE_FULL_ACCESS', 'LICENSE_CUSTOMER_CREATE'],
    },
  },
};

export default appPermissions;
